/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Edit_DescriptionInputs */

const es_feedback_modal_edit_description = /** @type {(inputs: Feedback_Modal_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edita tu problema o sugerencia.`)
};

const en_feedback_modal_edit_description = /** @type {(inputs: Feedback_Modal_Edit_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit your problem or suggestion.`)
};

/**
* | output |
* | --- |
* | "Edit your problem or suggestion." |
*
* @param {Feedback_Modal_Edit_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_edit_description = /** @type {((inputs?: Feedback_Modal_Edit_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Edit_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_edit_description(inputs)
	return en_feedback_modal_edit_description(inputs)
});
export { feedback_modal_edit_description as "feedback.modal.edit_description" }